module.exports = __webpack_public_path__ + "images/index/img11.75da754.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/pien/img11.jpg
// module id = Aubh
// module chunks = 21